import { useQuery } from "@tanstack/react-query";
import { getMeRequest } from "../api/getMe";
import { useAuthStore } from "@/app/store/auth.store";
import { QUERY_KEYS } from "@/shared/api/query-keys";

export const useGetMe = (options = {}) => {
  const logout = useAuthStore((s) => s.logout);
  const setUser = useAuthStore((s) => s.setUser);

  return useQuery({
    queryKey: [QUERY_KEYS.AUTH_ME],
    queryFn: async () => {
      try {
        const user = await getMeRequest();
        setUser(user);
        return user;
      } catch (err: any) {
        if (err.response?.status === 401) {
          logout();
        }
        throw err;
      }
    },
    retry: false,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    ...options,
  });
};
